import { render } from "./DemandSimulationSummary.vue?vue&type=template&id=97d0dbd8&ts=true"
import script from "./DemandSimulationSummary.vue?vue&type=script&lang=ts"
export * from "./DemandSimulationSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__